// extracted by mini-css-extract-plugin
module.exports = {"button":"AccordionPower_button__4MK0V","image":"AccordionPower_image__1B6dM","textPower":"AccordionPower_textPower__2YkEe"};